import React from 'react';
import { Card, Row } from 'react-bootstrap';

import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const StatsItemSkeleton = ({ className }) => {
  return (
    <Col xxl={3} md={6} className={`${className} px-0 py-xxl-0 px-md-3`}>
      <p className="fs--1 fw-semi-bold mb-0">
        <span className="text-800 fw-normal">
          <Skeleton />
        </span>
      </p>
      <h4 className="mb-1 font-sans-serif">
        <span className="fw-normal text-green-600">
          <Skeleton />
        </span>
      </h4>
    </Col>
  );
};

StatsItemSkeleton.propTypes = {
  className: PropTypes.string
};

const StatsSkeleton = () => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <Row className="g-0">
          <StatsItemSkeleton className="pb-2 ps-md-0" />
          <StatsItemSkeleton className="py-2 pt-md-0 pe-md-0" />
          <StatsItemSkeleton className="py-2 pb-md-0 ps-md-0 ps-xxl-3" />
          <StatsItemSkeleton className="pt-2 pb-0 pe-md-0" />
        </Row>
      </Card.Body>
    </Card>
  );
};

export default StatsSkeleton;
